/** Безопасный доступ к localStorage/sessionStorage (iOS private mode, WebView). */

export function safeGetItem(storage, key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSetItem(storage, key, value) {
  try {
    storage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeRemoveItem(storage, key) {
  try {
    storage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function getStoredToken() {
  return safeGetItem(localStorage, 'token');
}

export function setStoredToken(token) {
  return safeSetItem(localStorage, 'token', token);
}

export function removeStoredToken() {
  return safeRemoveItem(localStorage, 'token');
}
